import axios from 'axios';
import { adios } from '@adserve/adserve-react-components';
import { starter2Api, crmApi } from '../constants/Endpoint';

export const validate = async (rictFile) => {
    try {
        const response = await adios(() =>
            axios.post(`${starter2Api}/rictfile/validate`, { rictFile })
        );

        return response.data;

    } catch (err) {
        console.error(err);
    }
};

export const importRict = async (rictFileId, campaignInfo, rictInfo) => {
    const response = await adios(() =>
        axios.post(`${starter2Api}/rictfile/import`, { rictFileId, campaignInfo, rictInfo })
    );

    return response.data;
};

export const accountSearch = async (name, accountType) => {
    const results = await adios(() =>
        axios.get(`${crmApi}/Accounts/NamesByNameContains`, {
            params: {
                pageSize: -1,
                pageNumber: 1,
                name: encodeURIComponent(name),
                accountType
            }
        })
    );

    return results?.data?.data;
};

export const getMapping = async (discriminator, externalSourceId, name) => {
    const result = await adios(() =>
        axios.get(`${starter2Api}/Mapping`, {
            params: {
                discriminator,
                externalSourceId,
                name
            }
        })
    );
    return result?.data;
};
